/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "logo-mini-76dd03ba--sprite",
  "use": "logo-mini-76dd03ba--sprite-usage",
  "viewBox": "0 0 205 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 205 28\" id=\"logo-mini-76dd03ba--sprite\"><path d=\"M4.02 23.761v-8.253h8.113v-3.752H4.019V4.478h11.044V.726H0v26.787h15.063v-3.752H4.019zM37.04 7.817C36.101 3.202 33.735.238 28.701.238c-6.949 0-9.69 5.628-9.69 13.882 0 8.216 2.741 13.88 9.69 13.88 5.297 0 7.814-3.3 8.678-8.328h-4.057c-.714 3.452-2.292 4.465-4.808 4.465-4.02 0-5.41-3.752-5.41-10.018 0-6.265 1.39-10.016 5.41-10.016 2.516 0 3.756 1.088 4.507 3.714h4.02zM42.148.726v26.787h4.02V4.478h8.752v23.035h4.02V.726H42.147zm22.692 0v8.779c0 3.79.263 7.728 7.513 7.728 1.54 0 3.68-.187 5.221-.6v10.88h4.02V.726h-4.02v12.043a16.36 16.36 0 01-4.245.563c-4.47 0-4.47-2.139-4.47-4.24V.726H64.84z\" fill=\"#F30\" /><path d=\"M94.535.488v26.787h4.02V4.239h8.752v23.036h4.019V.488h-16.79zM126.129 0c-6.874 0-9.466 5.778-9.466 13.881 0 8.066 2.592 13.881 9.466 13.881 6.874 0 9.466-5.815 9.466-13.88 0-8.104-2.592-13.882-9.466-13.882zm0 23.898c-4.207 0-5.371-3.901-5.371-10.017 0-6.115 1.164-10.017 5.371-10.017 4.207 0 5.372 3.902 5.372 10.017 0 6.116-1.165 10.017-5.372 10.017zm14.81-23.41v26.787h6.648l6.424-20.935h1.051v20.935h3.869V.488h-6.648l-6.423 20.934h-1.052V.488h-3.869zm41.369 7.09C181.369 2.964 179.002 0 173.969 0c-6.949 0-9.692 5.628-9.692 13.881 0 8.216 2.743 13.881 9.692 13.881 5.296 0 7.813-3.301 8.677-8.328h-4.057c-.714 3.451-2.291 4.464-4.808 4.464-4.019 0-5.409-3.751-5.409-10.017 0-6.265 1.39-10.017 5.409-10.017 2.517 0 3.756 1.088 4.508 3.714h4.019zm5.108 19.697h4.019V15.382h4.432l4.395 11.893h4.245l-5.146-13.769L204.206.488h-4.244l-4.095 11.067h-4.432V.488h-4.019v26.787z\" fill=\"#000\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
